import { useEffect, useState } from 'react'
import {
  fetchAndActivateRemoteConfig,
  getConversationAutoReopenFromRemote,
  getConversationCloseActionFromRemote,
  getConversationCloseReadFromRemote,
} from 'configs/firebase'

/**
 * Fase 5 — encerrar e reabrir conversa.
 *
 * Três flags porque os passos têm risco diferente e devem poder subir em
 * ordem:
 *
 * - `closeRead` (Passos 1–3) é **defensivo**: ler `closedAt`, entrar em modo
 *   encerrado e tratar 409. Sem isso a tela toma 403 do SDK numa conversa
 *   encerrada. Pode subir sozinho, antes de qualquer botão novo.
 * - `autoReopen` (Passo 4) reabre o que o job de inatividade fechou. Precisa
 *   estar em produção **antes** de o backend ligar o job de 7 dias, senão todo
 *   retorno de acompanhamento encontra o chat bloqueado.
 * - `closeAction` (Passos 5–6) é o que **escreve**: encerra ao finalizar ou
 *   cancelar o atendimento. É o último a ligar.
 */
export function useConversationCloseFlags(): {
  closeRead: boolean
  autoReopen: boolean
  closeAction: boolean
} {
  const [flags, setFlags] = useState({
    closeRead: false,
    autoReopen: false,
    closeAction: false,
  })

  useEffect(() => {
    let cancelled = false
    void (async () => {
      await fetchAndActivateRemoteConfig()
      if (cancelled) return
      setFlags({
        closeRead: getConversationCloseReadFromRemote(),
        autoReopen: getConversationAutoReopenFromRemote(),
        closeAction: getConversationCloseActionFromRemote(),
      })
    })()
    return () => {
      cancelled = true
    }
  }, [])

  return flags
}
